module.exports = "/_next/static/images/9b23a396ebac09fd1ec0d52d2fda66eb-cart-outline.svg.webp";